'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProcessing = exports.getPathId = exports.getError = exports.getFiles = undefined;

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _reselect = require('reselect');

var _cloud = require('helpers/cloud');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getError = function _getError(state, service) {
  return (0, _get4.default)(state.cloud, [service, 'error']);
};
var _getFiles = function _getFiles(state, service) {
  return { service: service, files: (0, _get4.default)(state.cloud, [service, 'files']) };
};
var _getPathId = function _getPathId(state, service) {
  return (0, _get4.default)(state.cloud, [service, 'pathId']);
};
var _getProcessing = function _getProcessing(state, service) {
  return (0, _get4.default)(state.cloud, [service, 'processing']);
};

var getFiles = exports.getFiles = (0, _reselect.createSelector)([_getFiles, _getPathId], function (data, pathId) {
  return (0, _cloud.processFiles)(data.files[pathId], data.service);
});

var getError = exports.getError = (0, _reselect.createSelector)([_getError], function (error) {
  return error;
});

var getPathId = exports.getPathId = (0, _reselect.createSelector)([_getPathId], function (res) {
  return res;
});

var getProcessing = exports.getProcessing = (0, _reselect.createSelector)([_getProcessing], function (res) {
  return res;
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/cloud.js
// module id = 873
// module chunks = 1